<template>
  <img class="company-logo" v-if="preferences.author.logo" :src="logoSrc" :alt="preferences.author.name" />
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CompanyLogo',
  computed: {
    logoSrc () {
      return `${process.env.VUE_APP_API_DOMAIN}${this.preferences.author.logo}?token=${this.token}&t=${this.timestamp}`
    },
    ...mapState({
      token: state => state.report.token,
      timestamp: state => state.report.timestamp,
    }),
  },
}
</script>

<style lang="scss" scoped>
  .company-logo {
    position: absolute;
    top: 1rem;
    right: 1rem;
    max-height: 90px;

    &.square {
      max-width: 90px!important;
    }

    &.rectangle {
      max-width: 175px!important;
    }
  }
</style>
